/* eslint-disable react/prop-types */
/* eslint-disable func-names */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';

const ProgressBar = function (props) {
  return <LinearProgress variant="determinate" {...props} />;
};

export default ProgressBar;
